import { useFetchDashboardAccountingSummary } from '@hooks';
import loadable from '@loadable/component';
import { UIUtils } from '@utils';
import React, { memo } from 'react';
import trans from 'translation';
import { KContainer } from 'uikit';

import Carousel from '../components/Carousel';
import DoughnutWithLegends from '../components/DoughnutWithLegends';
import Today from '../components/Today';

const ContractExpired = loadable(() => import('./components/ContractExpired'));

const onViewContract = () => {
  UIUtils.popup.open({
    title: trans('contract_expired'),
    maxWidth: 'md',
    content: () => <ContractExpired />
  });
};

const mappedLabels = {
  numOfContractExpired: 'contract_expired',
  numOfPaid: 'paid',
  numOfUnpaid: 'unpaid',
  numOfOverdue: 'overdue',
  numOfUnderCreditLimit: 'under_credit_limit',
  numOfExceededCreditLimit: 'exceeded_credit_limit',
  numOfContractValid: 'contract_valid',
  numOfSynced: 'synced',
  numOfUnsynced: 'unsynced',
  numOfFailed: 'failed',
  numOfPartial: 'partial'
};

const mappedFunctions = {
  contract_expired: onViewContract
};

const Summary = () => {
  const {
    apClientQuery: { data: apClientData, isInitialLoading: isApClientLoading },
    apInvoiceQuery: {
      data: apInvoiceData,
      isInitialLoading: isApInvoiceLoading
    },
    arClientQuery: { data: arClientData, isInitialLoading: isArClientLoading },
    arInvoiceQuery: {
      data: arInvoiceData,
      isInitialLoading: isArInvoiceLoading
    },
    clientRateQuery: {
      data: clientRateData,
      isInitialLoading: isClientRateLoading
    },
    paymentChartQuery: {
      data: paymentChartData,
      isInitialLoading: isPaymentChartLoading
    }
  } = useFetchDashboardAccountingSummary();

  return (
    <Carousel.Container rightNode={<Today />}>
      <Carousel.Item title={trans('ar_summary')}>
        <KContainer.View dp="flex" row alignItems="flex-end" gap={'6rem'}>
          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={arClientData}
              mappedLabels={mappedLabels}
              isLoading={isArClientLoading}
              title={trans('client')}
            />
          </KContainer.View>

          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={arInvoiceData}
              mappedLabels={mappedLabels}
              isLoading={isArInvoiceLoading}
              title={trans('invoice')}
            />
          </KContainer.View>
        </KContainer.View>
      </Carousel.Item>
      <Carousel.Item title={trans('ap_summary')}>
        <KContainer.View dp="flex" row alignItems="flex-end" gap={'6rem'}>
          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={apClientData}
              mappedLabels={mappedLabels}
              isLoading={isApClientLoading}
              title={trans('client')}
            />
          </KContainer.View>

          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={apInvoiceData}
              mappedLabels={mappedLabels}
              isLoading={isApInvoiceLoading}
              title={trans('invoice')}
            />
          </KContainer.View>
        </KContainer.View>
      </Carousel.Item>
      <Carousel.Item title={trans('others')}>
        <KContainer.View dp="flex" row alignItems="flex-end" gap={'6rem'}>
          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={clientRateData}
              mappedLabels={mappedLabels}
              mappedFunctions={mappedFunctions}
              isLoading={isClientRateLoading}
              title={trans('client_rate_summary')}
            />
          </KContainer.View>

          <KContainer.View dp="flex" width={'50%'}>
            <DoughnutWithLegends
              data={paymentChartData}
              mappedLabels={mappedLabels}
              isLoading={isPaymentChartLoading}
              title={trans('payment_charts')}
            />
          </KContainer.View>
        </KContainer.View>
      </Carousel.Item>
    </Carousel.Container>
  );
};

export default memo(Summary);
